import React, {useState} from 'react';
import { Grid, InputLabel, MenuItem } from '@mui/material';
import { PrimaryOutlinedButton, PrimaryLightInput, PrimaryLightSelect } from '../../theme/index'
import '../../sass/styles.scss';
import FormControl from '@mui/material/FormControl';
import { useDispatch } from 'react-redux';
import { modalAction } from '../../redux/reducers/Modal';
import { createClientAction } from '../../redux/reducers/Create';

const ClientsCreate = () => {

    const dispatch = useDispatch();
    const [docType, setDocType] = useState('');
    const [docNumber, setDocNumber] = useState('');
    const [name, setName] = useState('');
    const [lname, setLname] = useState('');
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');

    const saveData = async () => {
        const client = new FormData();
        const dataNames = ["documentType", 'documentNumber', 'name', 'lastname', 'email', 'status'];

        client.append(dataNames[0], docType);
        client.append(dataNames[1], docNumber);
        client.append(dataNames[2], name);
        client.append(dataNames[3], lname);
        client.append(dataNames[4], email);
        client.append(dataNames[5], status);
        client.append('METHOD', 'POST');

        dispatch(createClientAction(client, dataNames));
        dispatch(modalAction());
    }

  return (
    <>
        <Grid item xs={ 10 }>
            <h5 style={{ margin: '0' }}>Cliente / nuevo</h5>
        </Grid>
        <Grid item xs={ 12 }>
            <Grid container sx={{ py: 6 }}>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Tipo de documento</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        label="Tipo de documento"
                        onChange={ e => setDocType(e.target.value) }
                        >
                            <MenuItem value='passport'>Pasaporte</MenuItem>
                            <MenuItem value="v">V-</MenuItem>
                            <MenuItem value="e">E-</MenuItem>
                            {/* <MenuItem value='identification'>Nº de identificación</MenuItem> */}
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nº de documento"
                        fullWidth
                        onChange={ e => setDocNumber(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Nombre"
                        fullWidth
                        onChange={ e => setName(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="Apellido"
                        fullWidth
                        onChange={ e => setLname(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <PrimaryLightInput
                        label="E-mail"
                        fullWidth
                        type='email'
                        onChange={ e => setEmail(e.target.value) }
                    />
                </Grid>
                <Grid item xs={ 12 } md={6} sx={{ mb: 2}} className='pr-2'>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Status</InputLabel>
                        <PrimaryLightSelect 
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        onChange={ e => setStatus(e.target.value) }
                        >
                            <MenuItem value='true'>Activo</MenuItem>
                            <MenuItem value='false'>Inactivo</MenuItem>
                        </PrimaryLightSelect>
                    </FormControl>
                </Grid>
                <Grid item xs={ 12 } sx={{ mt: 5 }} textAlign='end' className='pr-2'>
                    <PrimaryOutlinedButton onClick={ () => saveData() }>Guardar</PrimaryOutlinedButton>
                </Grid>
            </Grid>
        </Grid>
    </>
  )
}

export default ClientsCreate